var _rect, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSaveEarnPercentageUpIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.646484,
    width: 40,
    height: 40,
    rx: 12,
    fill: "#E7F0FE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 19.6465C18.2 19.6465 19.5 18.3465 19.5 16.6465C19.5 14.9465 18.2 13.6465 16.5 13.6465C14.8 13.6465 13.5 14.9465 13.5 16.6465C13.5 18.3465 14.8 19.6465 16.5 19.6465ZM16.5 15.6465C17.1 15.6465 17.5 16.0465 17.5 16.6465C17.5 17.2465 17.1 17.6465 16.5 17.6465C15.9 17.6465 15.5 17.2465 15.5 16.6465C15.5 16.0465 15.9 15.6465 16.5 15.6465Z",
    fill: "#86B4F9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 21.6465C22.8 21.6465 21.5 22.9465 21.5 24.6465C21.5 26.3465 22.8 27.6465 24.5 27.6465C26.2 27.6465 27.5 26.3465 27.5 24.6465C27.5 22.9465 26.2 21.6465 24.5 21.6465ZM24.5 25.6465C23.9 25.6465 23.5 25.2465 23.5 24.6465C23.5 24.0465 23.9 23.6465 24.5 23.6465C25.1 23.6465 25.5 24.0465 25.5 24.6465C25.5 25.2465 25.1 25.6465 24.5 25.6465Z",
    fill: "#86B4F9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5 13.6465H21.5V15.6465H24.1L13.8 25.9465C13.4 26.3465 13.4 26.9465 13.8 27.3465C14 27.5465 14.2 27.6465 14.5 27.6465C14.8 27.6465 15 27.5465 15.2 27.3465L25.5 17.0465V19.6465H27.5V14.6465C27.5 14.0465 27.1 13.6465 26.5 13.6465Z",
    fill: "#86B4F9"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveEarnPercentageUpIcon);
export default __webpack_public_path__ + "static/media/save-earn-percentage-up-icon.a579566f957e264d13235707d1f1a332.svg";
export { ForwardRef as ReactComponent };